/* -------------------------------------------------------------------------- */
/*                                 Dependecies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencie
import { useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import { useTranslation } from 'react-i18next';

// UI lib components
import { Box, Stack, TextInput } from '@mantine/core';

// UI local components
import ConfirmBar from '@app/shared/ui-kit/molecules/ConfirmBar';

// Context
import useWorkspace from '../store/hooks/useWorkspace';

// Store
import dialogStoreVar from '@app/features/Dialog/store/dialogStore';

// API & types
import { DialogWorkspaceArchiveProps } from './types';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

export default function DialogWorkspaceArchive({
  onConfirm,
}: DialogWorkspaceArchiveProps) {
  /* ********************************** HOOKS ********************************* */

  // Context
  const workspace = useWorkspace();

  // Store
  const dialogStore = useReactiveVar(dialogStoreVar);

  // State
  const [passkey, setPasskey] = useState('');

  // Localization
  const { t } = useTranslation(['Common', 'Workspace']);

  /* ******************************** RENDERING ******************************* */
  return (
    <Stack>
      <Box fw="normal">
        {t('Workspace:DialogWorkspaceArchive.typeWorkspaceName', {
          workspaceName: workspace.name,
        })}
      </Box>

      <TextInput onChange={(e) => setPasskey(e.target.value)} />

      <ConfirmBar
        onConfirm={() => {
          onConfirm();
          dialogStore?.closeDialog?.('dialog-workspace-archive');
        }}
        onCancel={() => {
          dialogStore?.closeDialog?.('dialog-workspace-archive');
        }}
        color="blackroomRed"
        disabled={passkey !== workspace.name}
      />
    </Stack>
  );
}
